import { useEffect, useRef } from 'react'

export const useInterval = (callback, delay) => {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    savedCallback.current()
  }, [])

  // I think this is the only thin needed.
  useEffect(() => {
    const id = window.setInterval(() => {
      savedCallback.current()
    }, delay)

    return () => window.clearInterval(id)
  }, [delay])
}
